import socketio from 'socket.io-client';
import settings from './settings';

let sio;
export default {
  instance(store) {
    if (!sio) {
      const url = store.getters.socketUrl;
      const socketOptions = {
        forceNew: true,
        transports: ['websocket'],
      };

      sio = socketio(url, socketOptions);
      sio.on('connect', () => store.dispatch('socket_connect'));
      sio.on('disconnect', () => {
        sio.disconnect();
        sio = null;
        store.dispatch('socket_disconnect', store);
      });
      sio.on('message', message => store.dispatch('socket_message', message));
    }

    return sio;
  },
  connect() {
    if (sio) sio.connect();
  },
  disconnect() {
    if (sio) sio.disconnect();
  },
  emit({
    event,
    options,
  }) {
    switch (event) {
      case 'subscribe':
        sio.emit(event, {
          language: settings.language,
          deliveryPlatform: settings.socket.deliveryPlatform,
          layoutType: settings.layout.type,
          layoutId: settings.layout.id,
          subscribeOptions: {
            fullBetMeta: settings.socket.subscribeOptions.fullBetMeta,
            excludeBetGroups: settings.socket.subscribeOptions.excludeBetGroups,
            betsCacheKey: settings.socket.subscribeOptions.betsCacheKey,
          },
        });
        break;
      case 'message':
        sio.emit(event, {
          type: options.type,
          channel: settings.company.cpv,
          data: options.data,
        });
        break;
      default:
    }
  },
  bindWindowListeners() {
    window.addEventListener('offline', () => {
      this.disconnect();
    });

    window.addEventListener('online', () => {
      // Add some timeout because of network resolve
      setTimeout(() => {
        this.connect();
      }, 500);
    });
  },
};
